<template>
  <v-select
    :items="budgetYearItem"
    :label="label"
    @change="onInput"
    v-model="model"
    color="primary"
    clearable
  ></v-select>
</template>

<script>
export default {
  name: 'year-select',
  data () {
    return {
      model: this.value
    }
  },
  computed: {
    budgetYearItem () {
      const startYear = (new Date()).getFullYear()
      const currentYear = (new Date()).getFullYear() + 1
      const range = (start, stop, step) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + (i * step))
      return range(currentYear, startYear, -1)
    }
  },
  methods: {
    onInput () {
      this.$emit('input', this.model)
    }
  },
  props: {
    value: {
      type: String
    },
    label: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
